(function () {
  // Set consent type for analytics (GDPR region)
  if (!localStorage.getItem('ConsentType')) {
    localStorage.setItem('ConsentType', 'GDPR');
  }

  var BREAKPOINT_LG = 1200;

  // Body scroll lock
  var bodyScrollLock = {
    isLocked: false,
    lock: function () {
      if (!this.isLocked) {
        this.isLocked = true;
        document.body.classList.add('body-scroll-lock');
      }
    },
    unlock: function () {
      if (this.isLocked) {
        this.isLocked = false;
        document.body.classList.remove('body-scroll-lock');
      }
    },
  };

  // Run callback on first user interaction or after timeout
  function onUserInteraction(callback, events, timeout) {
    var eventList = events || ['touchstart', 'mousemove', 'scroll', 'click', 'keydown'];
    var delay = typeof timeout === 'number' ? timeout : 1000;
    var timer;
    var triggered = false;

    if (typeof callback !== 'function') {
      throw new TypeError('Argument 1 must be a function');
    }

    eventList = Array.isArray(eventList) ? eventList : [eventList];

    var trigger = function () {
      if (triggered) return;
      triggered = true;
      clearTimeout(timer);
      eventList.forEach(function (evt) {
        window.removeEventListener(evt, trigger);
      });
      callback();
    };

    var init = function () {
      eventList.forEach(function (evt) {
        window.addEventListener(evt, trigger, { passive: true });
      });
      timer = setTimeout(trigger, delay);
    };

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
  }

  // CSS class constants
  var CLASSES = {
    HEADER: 'header',
    HEADER_STICKY: 'header--sticky',
    HEADER_STICKY_SHOW: 'header--stickyShow',
    HEADER_STICKY_SHADOW: 'header--stickyShadow',
    HEADER_MENU_ACTIVE: 'active-menu',
    HEADER_HAMBURGER: 'header__hamburger',
    HEADER_MENU_CLOSE: 'hamburger--close',
    HEADER_BLOCK_ANIMATION: 'stop-animation',
    BODY_OVERLAY: 'page-overlay',
    SUBMENU_ITEM_BUTTON: 'header-item-submenu',
    SUBMENU_ACTIVE: 'header-item-submenu-active',
    HEADER_SUBMENU_ACTIVE: 'header-submenu-active',
    HEADER_SUBMENU_BACK: 'header-submenu-back',
    HEADER_LOGIN: 'header-login-button',
  };

  // Submenu focus management on hover
  function setupSubmenuFocus() {
    var body = document.body;
    var header = body.querySelector('.' + CLASSES.HEADER);
    if (!header) return;
    var submenuWrappers = header.querySelectorAll('.' + CLASSES.SUBMENU_ITEM_BUTTON);

    var handleMouseEnter = function (e) {
      var currentTarget = e.currentTarget;
      var focusedEl = header.querySelector(':focus');
      if (focusedEl && focusedEl !== currentTarget && !currentTarget.contains(focusedEl)) {
        focusedEl.blur();
        var menuLink = currentTarget.querySelector('.' + CLASSES.SUBMENU_ITEM_BUTTON);
        if (menuLink) menuLink.focus();
      }
    };

    if (submenuWrappers && header) {
      for (var i = 0; i < submenuWrappers.length; i++) {
        submenuWrappers[i].addEventListener('mouseenter', handleMouseEnter);
      }
    }
  }

  // Main header logic
  var body = document.body;
  var header = body.querySelector('.' + CLASSES.HEADER);
  if (!header) return;

  var hamburger = header.querySelector('.' + CLASSES.HEADER_HAMBURGER);
  var loginButton = header.querySelector('.' + CLASSES.HEADER_LOGIN);
  var lastScrollTop = 0;
  var resizeTimer;
  var desktopQuery = window.matchMedia('(min-width:' + BREAKPOINT_LG + 'px)');
  var loginScriptLoaded = false;

  if ((body.classList.contains('lc-es') || body.classList.contains('lc-de') || body.classList.contains('lc-br') || body.classList.contains('lc-pl') || body.classList.contains('lc-fr') || body.classList.contains('lc-it')) && loginButton) {
    loginButton.relList.add('nofollow');
  }

  // Sticky header on scroll
  function handleScroll() {
    if (header.classList.contains(CLASSES.HEADER_MENU_ACTIVE)) return;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var headerHeight = header.clientHeight;
    var isScrollingDown = scrollTop > lastScrollTop;
    var isAtTop = scrollTop === 0;
    var isPastHeader = scrollTop > headerHeight;

    if (scrollTop > 0) {
      header.classList.add(CLASSES.HEADER_STICKY_SHADOW);
    } else {
      header.classList.remove(CLASSES.HEADER_STICKY_SHADOW);
    }

    if (isAtTop) {
      header.classList.remove(CLASSES.HEADER_STICKY);
      header.classList.remove(CLASSES.HEADER_STICKY_SHOW);
    } else {
      header.classList.add(CLASSES.HEADER_STICKY);
      if (isPastHeader && isScrollingDown) {
        header.classList.remove(CLASSES.HEADER_STICKY_SHOW);
      } else {
        header.classList.add(CLASSES.HEADER_STICKY_SHOW);
      }
    }

    lastScrollTop = scrollTop;
  }

  // Close all submenus
  function closeAllSubmenus() {
    header.querySelectorAll('.' + CLASSES.SUBMENU_ACTIVE).forEach(function (el) {
      el.classList.remove(CLASSES.SUBMENU_ACTIVE);
      if (desktopQuery.matches) {
        bodyScrollLock.unlock();
        body.classList.remove(CLASSES.BODY_OVERLAY);
      }
    });
    header.classList.remove(CLASSES.HEADER_SUBMENU_ACTIVE);
  }

  // Open a submenu
  function openSubmenu(submenu) {
    closeAllSubmenus();
    submenu.classList.add(CLASSES.SUBMENU_ACTIVE);
    header.classList.add(CLASSES.HEADER_SUBMENU_ACTIVE);
    if (desktopQuery.matches) {
      bodyScrollLock.lock();
      body.classList.add(CLASSES.BODY_OVERLAY);
    }
  }

  // Open mobile menu
  function openMenu() {
    header.classList.add(CLASSES.HEADER_MENU_ACTIVE);
    bodyScrollLock.lock();
  }

  // Close mobile menu
  function closeMenu() {
    header.classList.remove(CLASSES.HEADER_MENU_ACTIVE);
    if (hamburger) hamburger.classList.remove(CLASSES.HEADER_MENU_CLOSE);
    closeAllSubmenus();
    bodyScrollLock.unlock();
    body.classList.remove(CLASSES.BODY_OVERLAY);
  }

  // Toggle hamburger menu
  function toggleMenu() {
    if (header.classList.contains(CLASSES.HEADER_MENU_ACTIVE)) {
      closeMenu();
      hamburger.classList.remove(CLASSES.HEADER_MENU_CLOSE);
      body.classList.remove(CLASSES.BODY_OVERLAY);
    } else {
      openMenu();
      hamburger.classList.add(CLASSES.HEADER_MENU_CLOSE);
      body.classList.add(CLASSES.BODY_OVERLAY);
    }
  }

  // Handle submenu clicks (mobile)
  function handleSubmenuClick(e) {
    if (desktopQuery.matches) return;

    var target = e.target;
    var submenuButton = target.closest('.' + CLASSES.SUBMENU_ITEM_BUTTON);

    if (submenuButton) {
      e.preventDefault();
      if (submenuButton.classList.contains(CLASSES.SUBMENU_ACTIVE)) {
        closeAllSubmenus();
      } else {
        openSubmenu(submenuButton);
      }
      return;
    }

    if (target.closest('.' + CLASSES.HEADER_SUBMENU_BACK)) {
      e.preventDefault();
      closeAllSubmenus();
    }
  }

  // Block animations during resize
  function handleResize() {
    if (!header) return;
    header.classList.add(CLASSES.HEADER_BLOCK_ANIMATION);
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      header.classList.remove(CLASSES.HEADER_BLOCK_ANIMATION);
    }, 400);
  }

  // Handle click outside header
  function handleClickOutside(e) {
    var target = e.target;
    if (
      !header.contains(target) &&
      (header.classList.contains(CLASSES.HEADER_MENU_ACTIVE) ||
        header.classList.contains(CLASSES.HEADER_SUBMENU_ACTIVE))
    ) {
      closeMenu();
    }
  }

  // Lazy-load login script
  function loadLoginScript(scriptUrl) {
    if (!scriptUrl || loginScriptLoaded) return;
    var script = document.createElement('script');
    script.src = scriptUrl;
    document.head.appendChild(script);
    loginScriptLoaded = true;

    function normalizeRedirectUrl(url) {
      if (!url || typeof url !== 'string') return '';
      return url.replace(/#$/, '');
    }

    function resolveRedirectTarget(targetUrl, apiRedirectUrl) {
      var localizedConfig = window.lcHeaderConfig || {};
      return normalizeRedirectUrl(window.lcForcedLoginRedirectUrl) ||
        normalizeRedirectUrl(targetUrl) ||
        normalizeRedirectUrl(localizedConfig.redirectUrl) ||
        normalizeRedirectUrl(apiRedirectUrl) ||
        '/build-cv';
    }

    function ensureLoginRedirectCallbacks() {
      window.postLoginMethod = function (targetUrlToRevertFromAccountsGlobal, userId, redirectUrl) {
        var target = resolveRedirectTarget(targetUrlToRevertFromAccountsGlobal, redirectUrl);
        if (target) {
          window.location.replace(target);
        }
      };

      window.postRegisterMethod = function (isNewlyCreated, targetUrlToRevertFromAccountsGlobal, userId, redirectUrl) {
        var target = resolveRedirectTarget(targetUrlToRevertFromAccountsGlobal, redirectUrl);
        if (target) {
          window.location.replace(target);
        }
      };
    }

    function getLoginParams() {
      var localizedConfig = window.lcHeaderConfig || {};
      var hardcodedRedirectURL = localizedConfig.redirectUrl || '/build-cv';
      var productCD = localizedConfig.productCD || '';

      return {
        redirectURL: hardcodedRedirectURL,
        productCD: productCD,
      };
    }

    function isUserLoggedIn() {
      if (
        typeof LOGIN === 'object' &&
        LOGIN &&
        LOGIN.common &&
        typeof LOGIN.common.userStatus === 'function'
      ) {
        try {
          var userStatus = LOGIN.common.userStatus();
          if (userStatus && userStatus.IsUserLoggedIn) {
            return true;
          }
        } catch (e) {
          // Fall through to cookie parsing.
        }
      }

      var match = document.cookie.match(/(?:^|;\s*)UserStatus=([^;]+)/);
      if (!match) return false;

      try {
        var parsed = JSON.parse(decodeURIComponent(match[1]));
        return Boolean(parsed && parsed.IsUserLoggedIn);
      } catch (e) {
        return false;
      }
    }

    loginButton.addEventListener('click', function () {
      var loginParams = getLoginParams();
      ensureLoginRedirectCallbacks();

      // login.min.js uses this global callback target in multiple success paths.
      window.targetUrlToRevertFromAccountsGlobal = loginParams.redirectURL;
      // Keep a stable redirect source in case LOGIN object gets rehydrated/reset.
      window.lcForcedLoginRedirectUrl = loginParams.redirectURL;

      if (isUserLoggedIn()) {
        window.location.replace(loginParams.redirectURL);
        return;
      }

      if (
        typeof LOGIN === 'object' &&
        LOGIN &&
        LOGIN.Accounts &&
        typeof LOGIN.Accounts.setup === 'function'
      ) {
        LOGIN.Accounts.setup(loginParams.redirectURL, loginParams.productCD, false);
        LOGIN.postLoginRedirectURL = loginParams.redirectURL;
        LOGIN.productCD = loginParams.productCD;
      }

      if (typeof showLoginModal === 'function') {
        showLoginModal(loginParams.redirectURL, false);
      }
    });
  }

  // rAF-optimized scroll
  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (!scrollTicking) {
      window.requestAnimationFrame(function () {
        handleScroll();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  });

  // rAF-optimized resize
  var resizeTicking = false;
  window.addEventListener('resize', function () {
    if (!resizeTicking) {
      window.requestAnimationFrame(function () {
        handleResize();
        resizeTicking = false;
      });
      resizeTicking = true;
    }
  });

  // Login lazy-load on user interaction
  if (loginButton) {
    onUserInteraction(function () {
      var localizedConfig = window.lcHeaderConfig || {};
      loadLoginScript(localizedConfig.loginScriptUrl || header.getAttribute('data-login-script'));
    });
  }

  desktopQuery.addEventListener('change', function () { closeMenu(); });
  if (hamburger) hamburger.addEventListener('click', toggleMenu);
  header.addEventListener('click', handleSubmenuClick);
  document.addEventListener('click', handleClickOutside);
  setupSubmenuFocus();
})();


